<div class="main-container ac-table-page">
  <header class="page-header">
    <div class="title">
      <span class="title-text">Bookings</span>
      <p class="small-title">
        {{ pageDescription }}
      </p>
    </div>

    <div class="header-filter">
      @if(canView){
      <label class="drop-title" id="booking-utsav-label">Utsav</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="booking-utsav-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="utsav" placeholder="All utsavs" (selectionChange)="onUtsavChange()">
          <mat-option [value]="''">All utsavs</mat-option>
          @for(u of utsavList; track u.utsavId){
          <mat-option [value]="u.utsavId">
            {{ u.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      @if(canCreateManual){
      <button type="button" class="ac-primary-btn new-booking-btn" (click)="openManualBooking()">New Manual Booking</button>
      }
    </div>
  </header>

  @if(canView){
  <form class="search-bar" (submit)="submitSearch($event)">
    <div class="each-div">
      <label class="drop-title" for="booking-family-code">Family Code</label>
      <input id="booking-family-code" type="text" class="text-box-active" placeholder="Family code" autocomplete="off" inputmode="numeric" maxlength="12" [formControl]="familyCode" (input)="onFamilyCodeInput($event)" />
    </div>

    <div class="each-div">
      <label class="drop-title" for="booking-from-date">From Date</label>
      <input id="booking-from-date" type="date" class="text-box-active" [formControl]="fromDate" />
    </div>

    <div class="each-div">
      <label class="drop-title" for="booking-to-date">To Date</label>
      <input id="booking-to-date" type="date" class="text-box-active" [formControl]="toDate" />
    </div>

    <div class="each-div">
      <label class="drop-title" for="booking-guest-count">Guests</label>
      <input id="booking-guest-count" type="number" class="text-box-active" placeholder="Any" inputmode="numeric" min="1" [formControl]="guestCount" />
    </div>

    <div class="each-div">
      <label class="drop-title" id="booking-gender-label">Gender</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="booking-gender-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="gender" (selectionChange)="search()">
          @for(opt of genderOptions; track opt.value){
          <mat-option [value]="opt.value">
            {{ opt.label }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="each-div">
      <label class="drop-title" id="booking-view-label">View</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="booking-view-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="view" (selectionChange)="search()">
          @for(opt of viewOptions; track opt.value){
          <mat-option [value]="opt.value">
            {{ opt.label }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-actions">
      <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="reset()">Reset</button>
      <button type="submit" class="ac-primary-btn" [disabled]="isLoading">Search</button>
      @if(showAssignedBulkActions()){
      <button type="button" class="ac-primary-btn" [disabled]="isLoading || selectedIds.size === 0" (click)="confirmSelected()">Confirm selected (
        {{ selectedIds.size }})</button>
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="confirmAll()">Confirm all assigned</button>
      <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="revokeAll()">Revoke all assigned rooms</button>
      }
    </div>
  </form>

  <div class="table-container ac-table-region" role="region" aria-label="Branch bookings" tabindex="0">
    <table class="table data-table ac-responsive-table ac-sortable-table" matSort [matSortDisableClear]="true" (matSortChange)="sortBookings($event)">
      <thead class="table-head">
        <tr>
          @if(showSelection){
          <th scope="col" class="select-column">
            <input type="checkbox" [checked]="allSelected" [disabled]="isLoading" (change)="toggleSelectAll()" aria-label="Select all assigned bookings" />
          </th>
          }
          <th scope="col" mat-sort-header="bookingId" data-mobile-sort>Booking ID</th>
          <th scope="col" mat-sort-header="familyCode" data-mobile-sort>Family Code</th>
          <th scope="col" mat-sort-header="accommodationType">Accommodation</th>
          <th scope="col" mat-sort-header="guestCount">Guests</th>
          <th scope="col" mat-sort-header="bookingStatusCode" data-mobile-sort>Status</th>
          <th scope="col" mat-sort-header="lcStatusCode">Stage</th>
          <th scope="col" class="ac-actions-column">Actions</th>
        </tr>
      </thead>

      <tbody class="table-body">
        @for(booking of bookings; track booking.bookingId){
        <tr>
          @if(showSelection){
          <td class="select-column" data-label="Select">
            @if(canConfirm(booking)){
            <input type="checkbox" [checked]="isSelected(booking)" [disabled]="isLoading" (change)="toggleSelected(booking)" [attr.aria-label]="'Select booking ' + booking.bookingId" />
            }
          </td>
          }
          <td data-label="Booking ID">
            {{ booking.bookingId }}
          </td>
          <td data-label="Family Code">
            {{ booking.familyCode }}
            @if(booking.isAccompaniedByOnly){ <span class="accompanied-tag">Accompanied by only</span> }
          </td>
          <td data-label="Accommodation">
            {{ booking.accommodationType || '-' }}
          </td>
          <td data-label="Guests">
            {{ booking.guestCount }}
          </td>
          <td data-label="Status">
            {{ booking.bookingStatusCode || '-' }}
          </td>
          <td data-label="Stage">
            {{ booking.lcStatusCode || '-' }}
          </td>
          <td class="ac-actions-column" data-label="Actions">
            <div class="actions-cell">
              @let actions = rowActions(booking);
              @if(actions.length === 1){
              <button type="button" class="ac-secondary-small-btn" [class.ac-primary-btn]="actions[0].key === 'confirm'" [disabled]="isLoading" (click)="actions[0].run()">
                {{ actions[0].label }}
              </button>
              } @else if(actions.length > 1){
              @let inlineAction = (actions[0].key === 'confirm' || actions[0].key === 'assign') ? actions[0] : null;
              @let menuActions = inlineAction ? actions.slice(1) : actions;
              @if(inlineAction){
              <button type="button" class="ac-secondary-small-btn" [class.ac-primary-btn]="inlineAction.key === 'confirm'" [disabled]="isLoading" (click)="inlineAction.run()">
                {{ inlineAction.label }}
              </button>
              }
              <button type="button" class="ac-icon-btn more-btn" [disabled]="isLoading" [matMenuTriggerFor]="rowMenu" title="More actions">
                <span class="material-icons">more_vert</span>
              </button>
              <mat-menu #rowMenu="matMenu" class="ac-menu-panel" xPosition="before">
                @for(action of menuActions; track action.key){
                <button mat-menu-item type="button" [class.ac-menu-danger]="action.danger" (click)="action.run()">
                  {{ action.label }}
                </button>
                }
              </mat-menu>
              } @else {
              <span class="no-action">—</span>
              }
            </div>
          </td>
        </tr>
        }

        @if(hasSearched && !isLoading && bookings.length === 0){
        <tr class="ac-empty-table-row">
          <td [attr.colspan]="showSelection ? 8 : 7" class="empty-row">No Records Found</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>

<app-loader [isLoading]="isLoading"></app-loader>